import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service here
    console.error("ErrorBoundary caught an error:", error, errorInfo);
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center', 
          justifyContent: 'center', 
          height: '100%', 
          minHeight: '400px', 
          padding: '20px', 
          textAlign: 'center', 
          color: '#FFD700',
          background: '#111',
          borderRadius: '10px',
          border: '1px solid #333'
        }}>
          <div style={{ fontSize: '3rem', marginBottom: '10px' }}>⚠️</div>
          <h2 style={{ margin: '0 0 10px 0' }}>Something went wrong.</h2>
          <p style={{ color: '#ccc', marginBottom: '20px', maxWidth: '500px' }}>
            The application encountered an unexpected error. This might be due to a connection issue or a temporary glitch.
          </p>
          <button 
            onClick={this.handleRetry}
            style={{ padding: '12px 24px', background: '#FFD700', color: 'black', border: 'none', borderRadius: '5px', fontWeight: 'bold', cursor: 'pointer', fontSize: '1rem' }}
          >
            🔄 Reload Page
          </button>
        </div>
      );
    }

    return this.props.children; 
  }
}

export default ErrorBoundary;
